import React from "react";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  infoRow: {
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "#7070702d solid 2px",
    paddingTop: 15,
    paddingBottom: 15,
  },
});

export default function InfoRow({ label, data }) {
  const styles = useStyles();

  return (
    <Grid container item className={styles.infoRow} md={5.5}>
      <Grid item>{label}</Grid>
      <Grid item fontSize="12px">
        {data ? data : "No data"}
      </Grid>
    </Grid>
  );
}
